<template>
  <div>Auth0 Logout!</div>
</template>
